import { format } from "date-fns";
import { RecordingPlayer } from "./RecordingPlayer";

interface Recording {
  id: string;
  created_at: string;
  url: string;
  twilio_recording_sid: string;
  calie_calls: { from_number: string; to_number: string; duration_sec: number; };
}

interface RecordingItemProps {
  recording: Recording;
}

export function RecordingItem({ recording }: RecordingItemProps) {
  const durationInSeconds = recording.calie_calls?.duration_sec || 0;
  const minutes = Math.floor(durationInSeconds / 60);
  const seconds = durationInSeconds % 60;

  return (
    <div className="border rounded-lg p-4 space-y-2 hover:bg-gray-50 transition-colors">
      <div className="flex justify-between items-start">
        <div>
          <p className="font-medium">
            Call from {recording.calie_calls?.from_number || 'Unknown'}
          </p>
          <p className="text-sm text-gray-500">
            {format(new Date(recording.created_at), 'PPpp')}
          </p>
        </div>
        <div className="text-right">
          <p className="text-sm text-gray-500">
            Duration: {minutes}:{String(seconds).padStart(2, '0')}
          </p>
        </div>
      </div>
      
      {recording.url && (
        <div className="pt-2">
          <RecordingPlayer 
            recordingUrl={recording.url}
            recordingId={recording.id}
          />
        </div>
      )}
    </div>
  );
}